import { ref, watch, onMounted } from "@vue/composition-api";
import { line } from "d3";

export default function useLineChartLines(lineChartDataSetRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef) {
  const lines = ref([]);

  const updateLines = () => {
    if (!xRef?.value || !yRef?.value) {
      lines.value = [];
      return;
    }

    const halfXBandwidth = xBandwidthRef.value / 2;
    const lineGenerator = line()
      .x(d => xRef.value(d[0]) + halfXBandwidth)
      .y(d => yRef.value(d[1]))
      .defined(d => d != null);

    const pathData = new Map();
    const colors = new Map();
    const lineStyles = new Map();

    for (const val of lineChartDataSetRef.value) {
      const set = val.setName;

      colors[set] = val.setColor;
      lineStyles[set] = val.setLine;

      if (!pathData[set]) {
        pathData[set] = [];
      }

      if (val.x != null && val.y != null) {
        pathData[set].push([val.x, val.y]);
      }
    }

    lines.value = Object.keys(pathData).map((set) => {
      const generatedLine = lineGenerator(pathData[set]);

      return {
        id: `line-${set}`,
        class: `element-${set}`,
        fill: "none",
        color: colors[set],
        lineStyle: lineStyles[set] === "dashed" ? "2,2" : null,
        d: generatedLine,
        set,
      };
    });
  };

  watch([lineChartDataSetRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef], updateLines);

  onMounted(updateLines);

  return { lines };
}
